<template>
  <div class="wrapper-services">
    <p>
      Quais serviços você
      <br />utiliza na internet?
    </p>
    <p class="obs">*É possível selecionar mais de uma opção.</p>
    <div class="slide">
      <ul>
        <li
          :class="{ btn: selected2.includes(services[0].id) }"
          @click="
                        selected2.includes(services[0].id)
                            ? (selected2.splice(selected2.indexOf(services[0].id), 1),
                              selectedPoint.splice(selectedPoint.indexOf(services[0].point), 1))
                            : (selected2.push(services[0].id),
                              selectedPoint.push(services[0].point)),
                            addPlanMulti()
                    "
        >
          <svg
            class="socialmidia"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 169.639 175.664"
          >
            <g transform="translate(0.15 0.15)">
              <path
                :fill="iconColor"
                d="M138.076,1155.107h22.363a.964.964,0,1,0,0-1.928H138.076a.964.964,0,1,0,0,1.928Zm0-1.635h22.363a.671.671,0,1,1,0,1.342H138.076a.671.671,0,1,1,0-1.342Z"
                transform="translate(-65.161 -1147.914)"
              />
              <path
                :fill="iconColor"
                d="M127.508,1155.4a.146.146,0,1,0,0-.292.961.961,0,1,1,.961-.961.147.147,0,0,0,.294,0,1.255,1.255,0,1,0-1.255,1.253Z"
                transform="translate(-65.161 -1147.914)"
              />
              <path
                :fill="iconColor"
                d="M127.508,1153.6a.545.545,0,1,0,.546.546A.546.546,0,0,0,127.508,1153.6Z"
                transform="translate(-65.161 -1147.914)"
              />
              <path
                :fill="iconColor"
                d="M138.774,1300.5a1.615,1.615,0,0,0-1.121-1.052l-6.441-1.38-.39-2.36,2.071-4.691a4.786,4.786,0,0,0,.245-1.511v-3.273a6.734,6.734,0,0,0-13.467,0v3.273a4.8,4.8,0,0,0,.262,1.555l2.054,4.647-.39,2.36-6.472,1.388a1.606,1.606,0,0,0-1.092,1.049l-1.828,5.748a.868.868,0,0,0,.824,1.139H139.78a.868.868,0,0,0,.825-1.136Zm-25.618,6.061v0Zm.054-.169,1.775-5.579a.6.6,0,0,1,.38-.386l6.775-1.451a.5.5,0,0,0,.388-.409l.47-2.843a.5.5,0,0,0-.036-.284l-2.1-4.74a3.756,3.756,0,0,1-.194-1.194v-3.273a5.734,5.734,0,0,1,11.467,0v3.273a3.762,3.762,0,0,1-.177,1.15l-2.114,4.784a.5.5,0,0,0-.035.284l.469,2.843a.5.5,0,0,0,.388.409l6.744,1.443a.6.6,0,0,1,.41.389l1.776,5.584Z"
                transform="translate(-65.161 -1147.914)"
              />
              <g transform="translate(73.089 109.836)">
                <path
                  :fill="iconColor"
                  d="M143.966,1258.25h55.682a.25.25,0,0,0,0-.5H143.966a.25.25,0,1,0,0,.5Z"
                  transform="translate(-138.25 -1257.75)"
                />
                <path
                  :fill="iconColor"
                  d="M197.109,1262.417h-1.393a.25.25,0,1,0,0,.5h31.818a.25.25,0,1,0,0-.5H197.109Z"
                  transform="translate(-138.25 -1257.75)"
                />
                <path
                  :fill="iconColor"
                  d="M215.557,1271.75H165.841a.25.25,0,1,0,0,.5h49.716a.25.25,0,0,0,0-.5Z"
                  transform="translate(-138.25 -1257.75)"
                />
                <path
                  :fill="iconColor"
                  d="M227.5,1267.083h-89a.25.25,0,0,0,0,.5h89a.25.25,0,0,0,0-.5Z"
                  transform="translate(-138.25 -1257.75)"
                />
              </g>
              <path
                :fill="iconColor"
                d="M159.881,1245.392h26.751a.869.869,0,0,0,.826-1.134l-1.832-5.758a1.615,1.615,0,0,0-1.121-1.052l-6.441-1.38-.39-2.36,2.071-4.691a4.786,4.786,0,0,0,.245-1.511v-3.273a6.734,6.734,0,0,0-13.467,0v3.273a4.816,4.816,0,0,0,.262,1.555l2.054,4.647-.39,2.36-6.471,1.388a1.605,1.605,0,0,0-1.093,1.049l-1.829,5.751a.869.869,0,0,0,.825,1.136Zm26.625-.827v0Zm-24.669-5.752a.594.594,0,0,1,.381-.386l6.774-1.451a.5.5,0,0,0,.388-.409l.47-2.843a.5.5,0,0,0-.036-.284l-2.1-4.739a3.777,3.777,0,0,1-.194-1.2v-3.273a5.734,5.734,0,0,1,11.467,0v3.273a3.762,3.762,0,0,1-.177,1.15l-2.114,4.784a.5.5,0,0,0-.035.284l.469,2.843a.5.5,0,0,0,.388.409l6.744,1.443a.6.6,0,0,1,.41.389l1.776,5.584H160.062Zm-1.83,5.751h0Zm-.465-.155h0Z"
                transform="translate(-65.161 -1147.914)"
              />
              <path
                :fill="iconColor"
                d="M233.111,1252.5h-35v-64.573h1.178a.314.314,0,0,0,.315-.314v-10.729a.315.315,0,0,0-.315-.315h-1.178v-15.543A13.127,13.127,0,0,0,185,1147.914H113.773a13.127,13.127,0,0,0-13.112,13.112v15.543H99.483a.315.315,0,0,0-.315.315v10.729a.314.314,0,0,0,.315.314h1.178v1.678H99.483a.315.315,0,0,0-.315.314v.581H66.55a1.367,1.367,0,0,0-1.389,1.34v22.01a1.366,1.366,0,0,0,1.389,1.339h34.111v94.977a13.127,13.127,0,0,0,13.112,13.112H185a13.127,13.127,0,0,0,13.112-13.112v-32.977h35a1.366,1.366,0,0,0,1.389-1.339v-22.01A1.367,1.367,0,0,0,233.111,1252.5Zm-131.45-91.474a12.127,12.127,0,0,1,12.112-12.112H185a12.126,12.126,0,0,1,12.112,12.112V1252.5h-2.24v-91.162a10.222,10.222,0,0,0-10.211-10.211h-8.186a.25.25,0,0,0-.25.25v2.2a4.629,4.629,0,0,1-4.622,4.623H127.17a4.629,4.629,0,0,1-4.622-4.623v-2.2a.25.25,0,0,0-.25-.25h-8.186A10.224,10.224,0,0,0,103.9,1161.34v29.16h-2.24Zm32.728,116.163h3.7a.367.367,0,0,1,.389.339v7.612a1.321,1.321,0,0,0,.825,1.224,1.445,1.445,0,0,0,.567.116,1.408,1.408,0,0,0,.975-.389l9.193-8.79a.411.411,0,0,1,.287-.112h44.043v32.665a9.722,9.722,0,0,1-9.711,9.711H114.112a9.722,9.722,0,0,1-9.711-9.711v-94.665h44.934a.415.415,0,0,1,.287.111l9.194,8.791a1.408,1.408,0,0,0,.975.389,1.444,1.444,0,0,0,.566-.116,1.321,1.321,0,0,0,.825-1.224v-7.612a.367.367,0,0,1,.389-.339h3.7a1.366,1.366,0,0,0,1.389-1.339v-22.01a1.367,1.367,0,0,0-1.389-1.34H104.4v-29.16a9.723,9.723,0,0,1,9.711-9.711h7.936v1.948a5.13,5.13,0,0,0,5.122,5.123H171.6a5.13,5.13,0,0,0,5.122-5.123v-1.95h7.936a9.722,9.722,0,0,1,9.711,9.711V1252.5h-59.98a1.367,1.367,0,0,0-1.389,1.34v22.01A1.366,1.366,0,0,0,134.389,1277.189Zm-67.839-62.5a.865.865,0,0,1-.889-.839v-22.01a.865.865,0,0,1,.889-.84h98.723a.865.865,0,0,1,.888.84v22.01a.865.865,0,0,1-.888.839h-3.7a.865.865,0,0,0-.889.84v7.61a.9.9,0,0,1-1.521.59l-9.194-8.791a.917.917,0,0,0-.632-.249H66.55Zm130.559,95.477A12.125,12.125,0,0,1,185,1322.278H113.773a12.126,12.126,0,0,1-12.112-12.112v-94.977h2.24v94.665a10.222,10.222,0,0,0,10.211,10.211h70.546a10.222,10.222,0,0,0,10.211-10.211v-32.665h2.24ZM234,1275.85a.865.865,0,0,1-.889.839H150.326a.919.919,0,0,0-.632.249l-9.194,8.791a.9.9,0,0,1-1.521-.59v-7.61a.865.865,0,0,0-.889-.84h-3.7a.865.865,0,0,1-.889-.839v-22.01a.865.865,0,0,1,.889-.84h98.722a.865.865,0,0,1,.889.84Z"
                transform="translate(-65.161 -1147.914)"
              />
              <g transform="translate(6.716 47.836)">
                <path
                  :fill="iconColor"
                  d="M133.82,1209.75H84.1a.25.25,0,0,0,0,.5H133.82a.25.25,0,0,0,0-.5Z"
                  transform="translate(-71.877 -1195.75)"
                />
                <path
                  :fill="iconColor"
                  d="M161.161,1205.083h-89a.25.25,0,0,0,0,.5h89a.25.25,0,1,0,0-.5Z"
                  transform="translate(-71.877 -1195.75)"
                />
                <path
                  :fill="iconColor"
                  d="M100.014,1196.25H155.7a.25.25,0,0,0,0-.5H100.014a.25.25,0,0,0,0,.5Z"
                  transform="translate(-71.877 -1195.75)"
                />
                <path
                  :fill="iconColor"
                  d="M72.127,1200.917H99.371c.038.016.068.046.112.046h1.676v-.046h2.786a.25.25,0,1,0,0-.5H72.127a.25.25,0,0,0,0,.5Z"
                  transform="translate(-71.877 -1195.75)"
                />
              </g>
            </g>
          </svg>
          <p class="service-name">{{ services[0].name }}</p>
        </li>
        <li
          :class="{ btn: selected2.includes(services[1].id) }"
          @click="
                        selected2.includes(services[1].id)
                            ? (selected2.splice(selected2.indexOf(services[1].id), 1),
                              selectedPoint.splice(selectedPoint.indexOf(services[1].point), 1))
                            : (selected2.push(services[1].id),
                              selectedPoint.push(services[1].point)),
                            addPlanMulti()
                    "
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="spotify" viewBox="0 0 193.81 187.375">
            <g transform="translate(107.25 117.625)">
              <path
                :fill="iconColor"
                d="M403.5,1311.75a27.25,27.25,0,1,1,27.25-27.25A27.281,27.281,0,0,1,403.5,1311.75Zm0-54a26.75,26.75,0,1,0,26.75,26.75A26.78,26.78,0,0,0,403.5,1257.75Z"
                transform="translate(-376.25 -1257.25)"
              />
            </g>
            <g transform="translate(15.25 33.125)">
              <path
                :fill="iconColor"
                d="M311.5,1227.25A27.25,27.25,0,1,1,338.75,1200,27.281,27.281,0,0,1,311.5,1227.25Zm0-54A26.75,26.75,0,1,0,338.25,1200,26.78,26.78,0,0,0,311.5,1173.25Z"
                transform="translate(-284.25 -1172.75)"
              />
            </g>
            <g transform="translate(0 17.375)">
              <path
                :fill="iconColor"
                d="M350.5,1327h-78a3.5,3.5,0,0,1-3.5-3.5v-163a3.5,3.5,0,0,1,3.5-3.5h78a3.5,3.5,0,0,1,3.5,3.5v163A3.5,3.5,0,0,1,350.5,1327Zm-78-169a2.5,2.5,0,0,0-2.5,2.5v163a2.5,2.5,0,0,0,2.5,2.5h78a2.5,2.5,0,0,0,2.5-2.5v-163a2.5,2.5,0,0,0-2.5-2.5Z"
                transform="translate(-269 -1157)"
              />
            </g>
            <g transform="translate(92 102.375)">
              <path
                :fill="iconColor"
                d="M442.5,1327h-78a3.5,3.5,0,0,1-3.5-3.5v-78a3.5,3.5,0,0,1,3.5-3.5h78a3.5,3.5,0,0,1,3.5,3.5v78A3.5,3.5,0,0,1,442.5,1327Zm-78-84a2.5,2.5,0,0,0-2.5,2.5v78a2.5,2.5,0,0,0,2.5,2.5h78a2.5,2.5,0,0,0,2.5-2.5v-78a2.5,2.5,0,0,0-2.5-2.5Z"
                transform="translate(-361 -1242)"
              />
            </g>
            <g transform="translate(8.5 26.375)">
              <path
                :fill="iconColor"
                d="M311.5,1234a34,34,0,1,1,34-34A34.038,34.038,0,0,1,311.5,1234Zm0-67a33,33,0,1,0,33,33A33.038,33.038,0,0,0,311.5,1167Z"
                transform="translate(-277.5 -1166)"
              />
            </g>
            <g transform="translate(8.5 110.375)">
              <path
                :fill="iconColor"
                d="M311.5,1318a34,34,0,1,1,34-34A34.038,34.038,0,0,1,311.5,1318Zm0-67a33,33,0,1,0,33,33A33.038,33.038,0,0,0,311.5,1251Z"
                transform="translate(-277.5 -1250)"
              />
            </g>
            <g transform="translate(6.5 101.375)">
              <g transform="translate(70)">
                <circle :fill="iconColor" cx="1" cy="1" r="1" />
              </g>
              <circle :fill="iconColor" cx="1" cy="1" r="1" />
            </g>
            <g transform="translate(7 24.375)">
              <g transform="translate(70)">
                <circle :fill="iconColor" cx="1" cy="1" r="1" />
              </g>
              <circle :fill="iconColor" cx="1" cy="1" r="1" />
            </g>
            <g transform="translate(7 178.375)">
              <g transform="translate(70)">
                <circle :fill="iconColor" cx="1" cy="1" r="1" />
              </g>
              <circle :fill="iconColor" cx="1" cy="1" r="1" />
            </g>
            <g transform="translate(99 111.375)">
              <g transform="translate(70)">
                <circle :fill="iconColor" cx="1" cy="1" r="1" />
              </g>
              <circle :fill="iconColor" cx="1" cy="1" r="1" />
            </g>
            <g transform="translate(99 178.375)">
              <g transform="translate(70)">
                <circle :fill="iconColor" cx="1" cy="1" r="1" />
              </g>
              <circle :fill="iconColor" cx="1" cy="1" r="1" />
            </g>
            <g transform="translate(15.25 117.125)">
              <path
                :fill="iconColor"
                d="M311.5,1311.25A27.25,27.25,0,1,1,338.75,1284,27.281,27.281,0,0,1,311.5,1311.25Zm0-54A26.75,26.75,0,1,0,338.25,1284,26.78,26.78,0,0,0,311.5,1257.25Z"
                transform="translate(-284.25 -1256.75)"
              />
            </g>
            <g transform="translate(13.375 115.25)">
              <path
                :fill="iconColor"
                d="M311.5,1313.125A29.125,29.125,0,1,1,340.625,1284,29.157,29.157,0,0,1,311.5,1313.125Zm0-58A28.875,28.875,0,1,0,340.375,1284,28.907,28.907,0,0,0,311.5,1255.125Z"
                transform="translate(-282.375 -1254.875)"
              />
            </g>
            <g transform="translate(128.25 138.625)">
              <path
                :fill="iconColor"
                d="M403.5,1290.75a6.25,6.25,0,1,1,6.25-6.25A6.257,6.257,0,0,1,403.5,1290.75Zm0-12a5.75,5.75,0,1,0,5.75,5.75A5.757,5.757,0,0,0,403.5,1278.75Z"
                transform="translate(-397.25 -1278.25)"
              />
            </g>
            <g transform="translate(36.25 138.125)">
              <path
                :fill="iconColor"
                d="M311.5,1290.25a6.25,6.25,0,1,1,6.25-6.25A6.257,6.257,0,0,1,311.5,1290.25Zm0-12a5.75,5.75,0,1,0,5.75,5.75A5.757,5.757,0,0,0,311.5,1278.25Z"
                transform="translate(-305.25 -1277.75)"
              />
            </g>
            <g transform="translate(105.375 115.75)">
              <path
                :fill="iconColor"
                d="M403.5,1313.625a29.125,29.125,0,1,1,29.125-29.125A29.157,29.157,0,0,1,403.5,1313.625Zm0-58a28.875,28.875,0,1,0,28.875,28.875A28.907,28.907,0,0,0,403.5,1255.625Z"
                transform="translate(-374.375 -1255.375)"
              />
            </g>
            <g transform="translate(13.375 31.25)">
              <path
                :fill="iconColor"
                d="M311.5,1229.125A29.125,29.125,0,1,1,340.625,1200,29.157,29.157,0,0,1,311.5,1229.125Zm0-58A28.875,28.875,0,1,0,340.375,1200,28.907,28.907,0,0,0,311.5,1171.125Z"
                transform="translate(-282.375 -1170.875)"
              />
            </g>
            <g transform="translate(36.25 54.125)">
              <path
                :fill="iconColor"
                d="M311.5,1206.25a6.25,6.25,0,1,1,6.25-6.25A6.257,6.257,0,0,1,311.5,1206.25Zm0-12a5.75,5.75,0,1,0,5.75,5.75A5.757,5.757,0,0,0,311.5,1194.25Z"
                transform="translate(-305.25 -1193.75)"
              />
            </g>
            <g transform="translate(102.5 112.875)">
              <path
                :fill="iconColor"
                d="M403.5,1316.5a32,32,0,1,1,32-32A32.036,32.036,0,0,1,403.5,1316.5Zm0-63a31,31,0,1,0,31,31A31.035,31.035,0,0,0,403.5,1253.5Z"
                transform="translate(-371.5 -1252.5)"
              />
            </g>
            <g transform="translate(100 49.547)">
              <path
                :fill="iconColor"
                d="M381.938,1225.573H372.5a3.5,3.5,0,0,1-3.5-3.5v-29.4a3.5,3.5,0,0,1,3.5-3.5h9.438a.5.5,0,0,1,.5.5v35.4A.5.5,0,0,1,381.938,1225.573Zm-9.438-35.4a2.5,2.5,0,0,0-2.5,2.5v29.4a2.5,2.5,0,0,0,2.5,2.5h8.938v-34.4Z"
                transform="translate(-369 -1189.172)"
              />
            </g>
            <g transform="translate(180.372 49.547)">
              <path
                :fill="iconColor"
                d="M459.31,1225.573h-9.438a.5.5,0,0,1-.5-.5v-35.4a.5.5,0,0,1,.5-.5h9.438a3.5,3.5,0,0,1,3.5,3.5v29.4A3.5,3.5,0,0,1,459.31,1225.573Zm-8.938-1h8.938a2.5,2.5,0,0,0,2.5-2.5v-29.4a2.5,2.5,0,0,0-2.5-2.5h-8.938Z"
                transform="translate(-449.372 -1189.172)"
              />
            </g>
            <g transform="translate(112.438 47.633)">
              <path
                :fill="iconColor"
                d="M388.692,1227.487h-2.754a4.5,4.5,0,0,1-4.5-4.5v-31.229a4.5,4.5,0,0,1,4.5-4.5h2.754a2.36,2.36,0,0,1,2.358,2.357v35.515A2.36,2.36,0,0,1,388.692,1227.487Zm-2.754-39.229a3.5,3.5,0,0,0-3.5,3.5v31.229a3.5,3.5,0,0,0,3.5,3.5h2.754a1.359,1.359,0,0,0,1.358-1.357v-35.515a1.359,1.359,0,0,0-1.358-1.357Z"
                transform="translate(-381.438 -1187.258)"
              />
            </g>
            <g transform="translate(171.76 47.633)">
              <path
                :fill="iconColor"
                d="M445.872,1227.487h-2.754a2.36,2.36,0,0,1-2.358-2.357v-35.515a2.36,2.36,0,0,1,2.358-2.357h2.754a4.5,4.5,0,0,1,4.5,4.5v31.229A4.5,4.5,0,0,1,445.872,1227.487Zm-2.754-39.229a1.359,1.359,0,0,0-1.358,1.357v35.515a1.359,1.359,0,0,0,1.358,1.357h2.754a3.5,3.5,0,0,0,3.5-3.5v-31.229a3.5,3.5,0,0,0-3.5-3.5Z"
                transform="translate(-440.76 -1187.258)"
              />
            </g>
            <g transform="translate(106.03)">
              <path
                :fill="iconColor"
                d="M456.4,1190.047h-3.828a.375.375,0,0,1-.375-.375v-24.336a21.4,21.4,0,0,0-21.4-21.4h-29.8a21.4,21.4,0,0,0-21.4,21.4v24.336a.375.375,0,0,1-.375.375H375.4a.375.375,0,0,1-.375-.375v-26.383a22.009,22.009,0,0,1,6.488-15.663l1.514-1.514a22.008,22.008,0,0,1,15.663-6.487h34.42a22.006,22.006,0,0,1,15.663,6.487l1.514,1.514a22.008,22.008,0,0,1,6.488,15.663v26.383A.375.375,0,0,1,456.4,1190.047Zm-3.453-.75h3.078v-26.008a21.26,21.26,0,0,0-6.268-15.132l-1.514-1.513h0a21.257,21.257,0,0,0-15.133-6.269H398.7a21.259,21.259,0,0,0-15.133,6.269l-1.514,1.513a21.26,21.26,0,0,0-6.268,15.132V1189.3h3.078v-23.961a22.148,22.148,0,0,1,22.15-22.15h29.8a22.148,22.148,0,0,1,22.149,22.15Z"
                transform="translate(-375.03 -1139.625)"
              />
            </g>
            <g transform="translate(130.618 3.663)">
              <path
                :fill="iconColor"
                d="M431.247,1149.072a.423.423,0,0,1-.062,0l-4.4-.545a86.033,86.033,0,0,0-21.982.113l-3.218.431h-.01a1.791,1.791,0,0,1-1.958-1.609v-3.67a.5.5,0,0,1,.5-.5h32.531a.5.5,0,0,1,.5.5v3.67A1.778,1.778,0,0,1,431.247,1149.072Zm-30.629-4.784v3.17c0,.333.413.614.9.614l3.151-.426a86.981,86.981,0,0,1,22.238-.115l4.366.541c.476-.01.874-.288.874-.614v-3.17Z"
                transform="translate(-399.618 -1143.288)"
              />
            </g>
            <g transform="translate(186.237 88.9)">
              <g transform="translate(0 36.36)">
                <path
                  :fill="iconColor"
                  d="M455.612,1271.375a.375.375,0,0,1-.375-.375v-3.827a4.141,4.141,0,0,1,.582-2.1.375.375,0,0,1,.648.377,3.407,3.407,0,0,0-.48,1.726V1271A.375.375,0,0,1,455.612,1271.375Z"
                  transform="translate(-455.237 -1264.885)"
                />
              </g>
              <g transform="translate(0 32.546)">
                <path
                  :fill="iconColor"
                  d="M456.143,1265.634a.375.375,0,0,1-.324-.187,4.087,4.087,0,0,1,0-4.2.391.391,0,0,1,.648,0,3.416,3.416,0,0,0,2.973,1.728.375.375,0,1,1,0,.75,3.416,3.416,0,0,0-2.973,1.726A.375.375,0,0,1,456.143,1265.634Zm.06-3.46a3.288,3.288,0,0,0,0,2.344,1.212,1.212,0,1,0,0-2.344Z"
                  transform="translate(-455.237 -1261.071)"
                />
              </g>
              <g transform="translate(0.531 34.446)">
                <path
                  :fill="iconColor"
                  d="M459.44,1267.548a4.211,4.211,0,0,1-3.621-2.1.374.374,0,0,1,0-.377,4.212,4.212,0,0,1,3.621-2.1,4.165,4.165,0,0,1,2.719,1.013,1.705,1.705,0,0,1,0,2.55A4.16,4.16,0,0,1,459.44,1267.548Zm-2.855-2.289a3.411,3.411,0,0,0,5.084.707.954.954,0,0,0,0-1.413,3.412,3.412,0,0,0-5.084.706Z"
                  transform="translate(-455.768 -1262.971)"
                />
              </g>
              <g transform="translate(0 28.719)">
                <path
                  :fill="iconColor"
                  d="M456.143,1261.807h0a.377.377,0,0,1-.324-.187,4.087,4.087,0,0,1,0-4.2.391.391,0,0,1,.648,0,3.416,3.416,0,0,0,2.973,1.728.375.375,0,1,1,0,.75,3.416,3.416,0,0,0-2.973,1.726A.377.377,0,0,1,456.143,1261.807Zm.06-3.46a3.285,3.285,0,0,0,0,2.343,1.212,1.212,0,1,0,0-2.343Z"
                  transform="translate(-455.237 -1257.244)"
                />
              </g>
              <g transform="translate(0.531 30.619)">
                <path
                  :fill="iconColor"
                  d="M459.44,1263.721a4.211,4.211,0,0,1-3.621-2.1.374.374,0,0,1,0-.377,4.212,4.212,0,0,1,3.621-2.1,4.165,4.165,0,0,1,2.719,1.012,1.706,1.706,0,0,1,0,2.551A4.165,4.165,0,0,1,459.44,1263.721Zm-2.855-2.289a3.411,3.411,0,0,0,5.084.707.956.956,0,0,0,0-1.415,3.415,3.415,0,0,0-5.084.708Z"
                  transform="translate(-455.768 -1259.144)"
                />
              </g>
              <g transform="translate(0 24.891)">
                <path
                  :fill="iconColor"
                  d="M456.143,1257.979a.376.376,0,0,1-.324-.186,4.087,4.087,0,0,1,0-4.2.39.39,0,0,1,.648,0,3.415,3.415,0,0,0,2.973,1.727.375.375,0,1,1,0,.75,3.417,3.417,0,0,0-2.973,1.727A.376.376,0,0,1,456.143,1257.979Zm.06-3.459a3.285,3.285,0,0,0,0,2.343,1.212,1.212,0,1,0,0-2.343Z"
                  transform="translate(-455.237 -1253.416)"
                />
              </g>
              <g transform="translate(0.531 26.791)">
                <path
                  :fill="iconColor"
                  d="M459.44,1259.894a4.212,4.212,0,0,1-3.621-2.1.374.374,0,0,1,0-.377,4.213,4.213,0,0,1,3.621-2.1,4.166,4.166,0,0,1,2.719,1.013,1.706,1.706,0,0,1,0,2.551A4.166,4.166,0,0,1,459.44,1259.894Zm-2.855-2.29a3.41,3.41,0,0,0,5.084.708.956.956,0,0,0,0-1.415,3.413,3.413,0,0,0-5.084.707Z"
                  transform="translate(-455.768 -1255.316)"
                />
              </g>
              <g transform="translate(0 21.064)">
                <path
                  :fill="iconColor"
                  d="M456.143,1254.152h0a.376.376,0,0,1-.324-.186,4.087,4.087,0,0,1,0-4.2.39.39,0,0,1,.648,0,3.415,3.415,0,0,0,2.973,1.727.375.375,0,1,1,0,.75,3.417,3.417,0,0,0-2.973,1.727A.376.376,0,0,1,456.143,1254.152Zm.06-3.46a3.288,3.288,0,0,0,0,2.344,1.212,1.212,0,1,0,0-2.344Z"
                  transform="translate(-455.237 -1249.589)"
                />
              </g>
              <g transform="translate(0.531 22.964)">
                <path
                  :fill="iconColor"
                  d="M459.44,1256.066a4.211,4.211,0,0,1-3.621-2.1.374.374,0,0,1,0-.377,4.213,4.213,0,0,1,3.621-2.1,4.166,4.166,0,0,1,2.719,1.013,1.706,1.706,0,0,1,0,2.551A4.164,4.164,0,0,1,459.44,1256.066Zm-2.855-2.289a3.411,3.411,0,0,0,5.084.707.924.924,0,0,0,.313-.706.934.934,0,0,0-.313-.709,3.415,3.415,0,0,0-5.084.708Z"
                  transform="translate(-455.768 -1251.489)"
                />
              </g>
              <g transform="translate(0 17.237)">
                <path
                  :fill="iconColor"
                  d="M456.143,1250.325a.376.376,0,0,1-.324-.186,4.087,4.087,0,0,1,0-4.2.39.39,0,0,1,.648,0,3.415,3.415,0,0,0,2.973,1.727.375.375,0,1,1,0,.75,3.417,3.417,0,0,0-2.973,1.727A.376.376,0,0,1,456.143,1250.325Zm.06-3.46a3.288,3.288,0,0,0,0,2.344,1.212,1.212,0,1,0,0-2.344Z"
                  transform="translate(-455.237 -1245.762)"
                />
              </g>
              <g transform="translate(0.531 19.137)">
                <path
                  :fill="iconColor"
                  d="M459.44,1252.239a4.211,4.211,0,0,1-3.621-2.1.374.374,0,0,1,0-.377,4.213,4.213,0,0,1,3.621-2.1,4.161,4.161,0,0,1,2.719,1.013,1.706,1.706,0,0,1,0,2.551A4.168,4.168,0,0,1,459.44,1252.239Zm-2.855-2.289a3.411,3.411,0,0,0,5.084.707.955.955,0,0,0,0-1.414,3.413,3.413,0,0,0-5.084.707Z"
                  transform="translate(-455.768 -1247.662)"
                />
              </g>
              <g transform="translate(0 13.409)">
                <path
                  :fill="iconColor"
                  d="M456.143,1246.5h0a.376.376,0,0,1-.324-.186,4.089,4.089,0,0,1,0-4.2.39.39,0,0,1,.648,0,3.417,3.417,0,0,0,2.973,1.727.375.375,0,1,1,0,.75,3.414,3.414,0,0,0-2.973,1.728A.376.376,0,0,1,456.143,1246.5Zm.06-3.461a3.288,3.288,0,0,0,0,2.344,1.212,1.212,0,1,0,0-2.344Z"
                  transform="translate(-455.237 -1241.934)"
                />
              </g>
              <g transform="translate(0.531 15.309)">
                <path
                  :fill="iconColor"
                  d="M459.44,1248.412a4.214,4.214,0,0,1-3.621-2.1.374.374,0,0,1,0-.377,4.213,4.213,0,0,1,3.621-2.1,4.125,4.125,0,0,1,2.581.9,1.77,1.77,0,0,1,0,2.78A4.119,4.119,0,0,1,459.44,1248.412Zm-2.855-2.289a3.413,3.413,0,0,0,4.971.8,1.02,1.02,0,0,0,0-1.6,3.412,3.412,0,0,0-4.97.8Z"
                  transform="translate(-455.768 -1243.834)"
                />
              </g>
              <g transform="translate(0 9.583)">
                <path
                  :fill="iconColor"
                  d="M456.143,1242.671h0a.373.373,0,0,1-.324-.187,4.087,4.087,0,0,1,0-4.2.391.391,0,0,1,.648,0,3.417,3.417,0,0,0,2.973,1.727.375.375,0,1,1,0,.75,3.415,3.415,0,0,0-2.973,1.727A.375.375,0,0,1,456.143,1242.671Zm.06-3.461a3.288,3.288,0,0,0,0,2.344,1.212,1.212,0,1,0,0-2.344Z"
                  transform="translate(-455.237 -1238.108)"
                />
              </g>
              <g transform="translate(0.531 11.482)">
                <path
                  :fill="iconColor"
                  d="M459.44,1244.584a4.213,4.213,0,0,1-3.621-2.1.374.374,0,0,1,0-.377,4.213,4.213,0,0,1,3.621-2.1,4.164,4.164,0,0,1,2.719,1.014,1.705,1.705,0,0,1,0,2.55A4.161,4.161,0,0,1,459.44,1244.584Zm-2.855-2.288a3.413,3.413,0,0,0,5.084.707.955.955,0,0,0,0-1.414,3.411,3.411,0,0,0-5.084.707Z"
                  transform="translate(-455.768 -1240.007)"
                />
              </g>
              <g transform="translate(0 5.755)">
                <path
                  :fill="iconColor"
                  d="M456.143,1238.844h0a.375.375,0,0,1-.324-.187,4.087,4.087,0,0,1,0-4.2.391.391,0,0,1,.648,0,3.417,3.417,0,0,0,2.973,1.727.375.375,0,1,1,0,.75,3.415,3.415,0,0,0-2.973,1.727A.377.377,0,0,1,456.143,1238.844Zm.06-3.461a3.288,3.288,0,0,0,0,2.344,1.212,1.212,0,1,0,0-2.344Z"
                  transform="translate(-455.237 -1234.281)"
                />
              </g>
              <g transform="translate(0.531 7.655)">
                <path
                  :fill="iconColor"
                  d="M459.44,1240.757a4.213,4.213,0,0,1-3.621-2.1.374.374,0,0,1,0-.377,4.211,4.211,0,0,1,3.621-2.1,4.164,4.164,0,0,1,2.719,1.013,1.705,1.705,0,0,1,0,2.55A4.162,4.162,0,0,1,459.44,1240.757Zm-2.855-2.288a3.413,3.413,0,0,0,5.084.707.955.955,0,0,0,0-1.414,3.411,3.411,0,0,0-5.084.707Z"
                  transform="translate(-455.768 -1236.18)"
                />
              </g>
              <path
                :fill="iconColor"
                d="M456.144,1235.017a.375.375,0,0,1-.325-.187,4.139,4.139,0,0,1-.582-2.1V1228.9a.375.375,0,0,1,.75,0v3.828a3.406,3.406,0,0,0,.48,1.725.375.375,0,0,1-.323.564Z"
                transform="translate(-455.237 -1228.525)"
              />
              <g transform="translate(0.531 3.828)">
                <path
                  :fill="iconColor"
                  d="M459.44,1236.93a4.213,4.213,0,0,1-3.621-2.1.374.374,0,0,1,0-.377,4.211,4.211,0,0,1,3.621-2.1,4.164,4.164,0,0,1,2.719,1.013,1.706,1.706,0,0,1,0,2.551A4.167,4.167,0,0,1,459.44,1236.93Zm-2.855-2.288a3.413,3.413,0,0,0,5.084.707.955.955,0,0,0,0-1.414,3.411,3.411,0,0,0-5.084.707Z"
                  transform="translate(-455.768 -1232.353)"
                />
              </g>
            </g>
            <g transform="translate(185.406 85.198)">
              <path
                :fill="iconColor"
                d="M456.079,1230.107h-.933a.741.741,0,0,1-.74-.74v-4.294a.251.251,0,0,1,.25-.25h1.913a.25.25,0,0,1,.25.25v4.294A.741.741,0,0,1,456.079,1230.107Zm-1.173-4.784v4.044a.24.24,0,0,0,.24.24h.933a.24.24,0,0,0,.24-.24v-4.044Z"
                transform="translate(-454.406 -1224.823)"
              />
            </g>
          </svg>
          <p class="service-name">{{ services[1].name }}</p>
        </li>
        <li
          :class="{ btn: selected2.includes(services[2].id) }"
          @click="
                        selected2.includes(services[2].id)
                            ? (selected2.splice(selected2.indexOf(services[2].id), 1),
                              selectedPoint.splice(selectedPoint.indexOf(services[2].point), 1))
                            : (selected2.push(services[2].id),
                              selectedPoint.push(services[2].point)),
                            addPlanMulti()
                    "
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="netflix" viewBox="0 0 151 132.414">
            <path
              :fill="iconColor"
              d="M685.5,1214h-133a6.443,6.443,0,0,0-.388-2.191l132.711-35.561a.5.5,0,0,0,.354-.613l-4.141-15.453a3.5,3.5,0,0,0-4.286-2.477l-139.094,37.271a3.488,3.488,0,0,0-2.1,1.6c-.007.012-.017.022-.024.034a3.486,3.486,0,0,0-.352,2.656l3.365,12.555a3.467,3.467,0,0,0,.982,1.629c-.015.183-.028.366-.028.553h-4a.5.5,0,0,0-.5.5v72a3.5,3.5,0,0,0,3.5,3.5h144a3.5,3.5,0,0,0,3.5-3.5v-72A.5.5,0,0,0,685.5,1214Zm-8.492-55.328a2.507,2.507,0,0,1,.651-.087,2.507,2.507,0,0,1,2.411,1.855l4.012,14.971h0L662.1,1162.667Zm-33.7,9.029,22.627,12.572-17.794,4.768L626.163,1172.3Zm-35.936,9.629L630,1189.9l-17.793,4.768-21.981-12.745Zm-35.937,9.63,22.626,12.571-17.793,4.768-21.981-12.744Zm-31.926,24.6L536.147,1199a2.491,2.491,0,0,1,.261-1.911l21.719,12.068-6.426,1.721a6.5,6.5,0,0,0-11.931,1.276A2.5,2.5,0,0,1,539.512,1211.56ZM551.5,1214a5.5,5.5,0,0,1-10.9,1,5.355,5.355,0,0,1-.091-.9c0-.033-.005-.065-.005-.1a5.45,5.45,0,0,1,.093-.98,5.5,5.5,0,0,1,10.907.98ZM685,1286.5a2.5,2.5,0,0,1-2.5,2.5h-144a2.5,2.5,0,0,1-2.5-2.5V1215h3.585a6.449,6.449,0,0,0,.795,2.25H538.5a.25.25,0,0,0,0,.5h2.2a6.482,6.482,0,0,0,10.6,0H683.5a.25.25,0,0,0,0-.5H551.62a6.449,6.449,0,0,0,.795-2.25H685Z"
              transform="translate(-535 -1157.586)"
            />
            <path
              :fill="iconColor"
              d="M549.527,1212.5a3.824,3.824,0,0,0-7.3.885,3.768,3.768,0,0,0-.062.614,3.718,3.718,0,0,0,.04.4,3.664,3.664,0,0,0,.109.6,3.874,3.874,0,0,0,2.9,2.75,3.782,3.782,0,0,0,1.576,0,3.874,3.874,0,0,0,2.9-2.75,3.762,3.762,0,0,0,.149-1A3.8,3.8,0,0,0,549.527,1212.5Zm-.885,2.5a2.821,2.821,0,0,1-5.284,0,2.79,2.79,0,0,1-.171-.8c-.005-.067-.02-.132-.02-.2a2.8,2.8,0,0,1,.151-.871,2.83,2.83,0,0,1,5.515.871A2.8,2.8,0,0,1,548.642,1215Z"
              transform="translate(-535 -1157.586)"
            />
            <path
              :fill="iconColor"
              d="M683.5,1286.25h-145a.25.25,0,0,0,0,.5h145a.25.25,0,0,0,0-.5Z"
              transform="translate(-535 -1157.586)"
            />
            <g transform="translate(60.5 66.414)">
              <path
                :fill="iconColor"
                d="M666.042,1254.9l-.043-.277-.077-.495-.184-1.192-1.932-12.5a1.316,1.316,0,0,0-2.125-.825l-11.409,9.17a1.314,1.314,0,0,0,.349,2.251l6.7,2.6,2.561.994,1.064.413,3.317,1.287a1.316,1.316,0,0,0,1.776-1.428Z"
                transform="translate(-595.5 -1224)"
              />
              <path
                :fill="iconColor"
                d="M676.593,1255.044a3,3,0,0,0-3.237-2.742l-5.658.469-.864-5.584-1.428-9.239a2,2,0,0,0-3.23-1.254l-7.287,5.857-7.287,5.857a2,2,0,0,0,.53,3.423l5.438,2.111-15.767,1.307a13.96,13.96,0,0,0-18.622-15.379,5.942,5.942,0,0,1,.819-1.031v-5.178a6,6,0,0,1-1.757-4.243l-3.662-3.661a6,6,0,0,1-4.242-1.757h-5.178a6,6,0,0,1-4.242,1.757l-3.662,3.661a6,6,0,0,1-1.757,4.243v5.178a6,6,0,0,1,1.757,4.243l3.662,3.661a6,6,0,0,1,4.242,1.757h5.178a6.077,6.077,0,0,1,.6-.52,13.957,13.957,0,0,0,10.662,18.8l.8,9.675a3,3,0,0,0,3.237,2.742l49.6-4.111a3,3,0,0,0,2.742-3.238ZM650.44,1251.5a1.815,1.815,0,0,1-.481-3.108l11.409-9.17a1.816,1.816,0,0,1,2.932,1.138l1.938,12.536.184,1.191.077.495.037.243a1.82,1.82,0,0,1-1.789,2.1,1.828,1.828,0,0,1-.662-.125l-4.276-1.659-1.064-.414-2.561-.994Zm-40.386-3.933-.073.074h-4.462l-.073-.074a5.717,5.717,0,0,0-4.066-1.684h-.1l-3.155-3.155v-.1a5.787,5.787,0,0,0-1.684-4.065l-.073-.074v-4.462l.073-.074a5.787,5.787,0,0,0,1.684-4.065v-.1l3.155-3.155h.1a5.717,5.717,0,0,0,4.066-1.684l.073-.074h4.462l.073.074a5.717,5.717,0,0,0,4.066,1.684h.1l3.155,3.155v.1a5.787,5.787,0,0,0,1.684,4.065l.073.074v4.462l-.073.074a5.8,5.8,0,0,0-1.658,3.554c-.016.17-.026.34-.026.511v.1l-3.155,3.155h-.1c-.025,0-.048.007-.073.007a5.791,5.791,0,0,0-.662.065,5.663,5.663,0,0,0-1.766.523A5.758,5.758,0,0,0,610.054,1247.563Zm1.2,5.437a12.663,12.663,0,0,1,1.488-5.963,6.047,6.047,0,0,1,.68-.18,12.221,12.221,0,0,0,8.038,18.123l.043.52A12.769,12.769,0,0,1,611.25,1253Zm7.072-10.845a5.8,5.8,0,0,1,.129-.616A12.72,12.72,0,0,1,636.75,1253a12.782,12.782,0,0,1-.227,2.355l-.512.042a12.236,12.236,0,0,0-17.689-13.242Zm57.433,30.728a3.225,3.225,0,0,1-2.212,1.138l-46.4,3.846q-.137.012-.273.012a3.251,3.251,0,0,1-3.233-2.983l-.659-7.948-.1-1.255-.042-.5-.349-4.206a3.249,3.249,0,0,1,2.971-3.506l10.244-.85.527-.043,1.319-.11,18.585-1.54.715.278.349.135-19.781,1.64-1.354.112-.549.045-10.014.831a2.749,2.749,0,0,0-2.514,2.967l.355,4.273.041.5.1,1.255.654,7.881a2.753,2.753,0,0,0,2.967,2.514l46.4-3.846a2.749,2.749,0,0,0,2.514-2.967l-1.154-13.911a2.753,2.753,0,0,0-2.738-2.524c-.076,0-.152,0-.229.01l-3.937.326-.076-.495,3.972-.329a3.249,3.249,0,0,1,3.506,2.971l1.154,13.911A3.231,3.231,0,0,1,675.755,1272.883Z"
                transform="translate(-595.5 -1224)"
              />
              <path
                :fill="iconColor"
                d="M613.783,1245.406c.078-.005.154-.025.233-.026l2.864-2.864c0-.032.009-.062.01-.094a6.255,6.255,0,0,1,.292-1.645,6.192,6.192,0,0,1,1.454-2.5v-4.05a6.206,6.206,0,0,1-1.756-4.241l-2.864-2.864a6.2,6.2,0,0,1-4.241-1.757h-4.05a6.2,6.2,0,0,1-4.241,1.757l-2.864,2.864a6.206,6.206,0,0,1-1.756,4.241v4.05a6.206,6.206,0,0,1,1.756,4.241l2.864,2.864a6.2,6.2,0,0,1,4.241,1.757h4.05a6.356,6.356,0,0,1,4.008-1.731Z"
                transform="translate(-595.5 -1224)"
              />
            </g>
            <g transform="translate(8.039 76)">
              <path
                :fill="iconColor"
                d="M1674.947,648.748a1.285,1.285,0,0,1,0,2.226l-4.875,2.815L1665.2,656.6a1.285,1.285,0,0,1-1.927-1.113v-11.26a1.284,1.284,0,0,1,1.927-1.112l4.876,2.815Z"
                transform="translate(-1648.308 -629.868)"
              />
              <circle :fill="iconColor" cx="20" cy="20" r="20" transform="translate(-0.447)" />
              <circle :fill="iconColor" cx="18" cy="18" r="18" transform="translate(1.553 2)" />
            </g>
          </svg>
          <p class="service-name">{{ services[2].name }}</p>
        </li>
        <li
          :class="{ btn: selected2.includes(services[3].id) }"
          @click="
                        selected2.includes(services[3].id)
                            ? (selected2.splice(selected2.indexOf(services[3].id), 1),
                              selectedPoint.splice(selectedPoint.indexOf(services[3].point), 1))
                            : (selected2.push(services[3].id),
                              selectedPoint.push(services[3].point)),
                            addPlanMulti()
                    "
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="games" viewBox="0 0 127.198 153.901">
            <g transform="translate(0.1)">
              <g transform="translate(0 94.98)">
                <path
                  :fill="iconColor"
                  d="M860.87,1283.912h-.238a29.083,29.083,0,0,1-24.07-13.077l-20.382-.161a29.079,29.079,0,0,1-24.041,12.7h-.233a29.141,29.141,0,0,1-.266-58.276l70.17.555h.012A29.321,29.321,0,0,1,890,1255.007a29.136,29.136,0,0,1-29.128,28.905Zm-44.954-14.241h0l20.918.165a.5.5,0,0,1,.415.227,28.086,28.086,0,0,0,23.387,12.848h.23A28.134,28.134,0,0,0,889,1255a28.316,28.316,0,0,0-27.2-28.353l-70.15-.555a28.141,28.141,0,0,0,.269,56.276h.225a28.084,28.084,0,0,0,23.362-12.476A.5.5,0,0,1,815.916,1269.671Z"
                  transform="translate(-763.001 -1225.091)"
                />
                <g transform="translate(5.977 5.981)">
                  <path
                    :fill="iconColor"
                    d="M792.144,1277.391h-.19a23.159,23.159,0,0,1,.178-46.318h.189a23.159,23.159,0,0,1-.177,46.318Zm-.012-45.819a22.692,22.692,0,1,0,.185,0Z"
                    transform="translate(-768.978 -1231.072)"
                  />
                </g>
                <g transform="translate(74.702 6.526)">
                  <path
                    :fill="iconColor"
                    d="M860.868,1277.936h-.189a23.159,23.159,0,0,1,.177-46.318h.19a23.159,23.159,0,0,1-.178,46.318Zm-.012-45.819a22.659,22.659,0,0,0-.173,45.318h.185a22.66,22.66,0,0,0,22.653-22.48h0a22.657,22.657,0,0,0-22.479-22.838Z"
                    transform="translate(-837.703 -1231.617)"
                  />
                </g>
                <g transform="translate(25.791 25.797)">
                  <path
                    :fill="iconColor"
                    d="M792.138,1257.578h-.027a3.348,3.348,0,1,1,2.373-.962h0A3.325,3.325,0,0,1,792.138,1257.578Zm0-6.286a2.941,2.941,0,0,0-.024,5.881h.024a2.918,2.918,0,0,0,2.062-.846h0a2.94,2.94,0,0,0-2.063-5.035Z"
                    transform="translate(-788.792 -1250.888)"
                  />
                </g>
                <g transform="translate(56.168 24.862)">
                  <path
                    :fill="iconColor"
                    d="M825.091,1251.824h0l-5.727-.045a.2.2,0,0,1-.193-.2l.011-1.433a.2.2,0,0,1,.058-.137.146.146,0,0,1,.139-.057l5.727.046a.2.2,0,0,1,.194.2l-.012,1.432A.2.2,0,0,1,825.091,1251.824Zm-5.53-.433,5.336.042.009-1.042-5.338-.043Z"
                    transform="translate(-819.169 -1249.953)"
                  />
                </g>
                <g transform="translate(64.758 24.933)">
                  <path
                    :fill="iconColor"
                    d="M833.682,1251.893h0l-5.728-.046a.2.2,0,0,1-.137-.059.2.2,0,0,1-.056-.139l.012-1.431a.194.194,0,0,1,.2-.194h0l5.726.046a.2.2,0,0,1,.194.2l-.011,1.432a.2.2,0,0,1-.2.194Zm-5.532-.435,5.338.043.008-1.042-5.337-.043Z"
                    transform="translate(-827.759 -1250.024)"
                  />
                </g>
                <g transform="translate(16.02 16.023)">
                  <path
                    :fill="iconColor"
                    d="M795.725,1267.349h-.01l-7.363-.058a1.125,1.125,0,0,1-1.114-1.132l.057-7.161-7.161-.057a1.122,1.122,0,0,1-1.113-1.131l.058-7.364a1.122,1.122,0,0,1,1.122-1.114h.009l7.161.057.057-7.161a1.123,1.123,0,0,1,1.122-1.114h.01l7.363.058a1.122,1.122,0,0,1,1.113,1.133l-.056,7.16,7.162.056h0a1.125,1.125,0,0,1,1.113,1.132l-.059,7.364a1.125,1.125,0,0,1-1.123,1.114h-.009l-7.16-.057-.057,7.161a1.123,1.123,0,0,1-1.122,1.114ZM780.2,1249.737a.719.719,0,0,0-.718.712l-.058,7.364a.717.717,0,0,0,.713.723l7.363.059a.2.2,0,0,1,.2.2l-.058,7.363a.719.719,0,0,0,.712.724l7.364.058h.006a.717.717,0,0,0,.717-.712l.059-7.363a.216.216,0,0,1,.2-.2l7.363.059h.005a.719.719,0,0,0,.719-.712l.059-7.364a.719.719,0,0,0-.713-.723l-7.364-.058a.2.2,0,0,1-.2-.2l.058-7.364a.717.717,0,0,0-.713-.723l-7.363-.059h-.005a.719.719,0,0,0-.719.712l-.058,7.363a.2.2,0,0,1-.06.143.17.17,0,0,1-.144.058l-7.364-.058Z"
                    transform="translate(-779.021 -1241.114)"
                  />
                </g>
                <g transform="translate(17.976 27.11)">
                  <path
                    :fill="iconColor"
                    d="M784.76,1256.115h0l-3.682-.028a.1.1,0,0,1-.1-.1l.028-3.682a.112.112,0,0,1,.03-.072.107.107,0,0,1,.071-.029h0l3.683.029a.1.1,0,0,1,.09.057l.9,1.849a.1.1,0,0,1,0,.091l-.934,1.833A.1.1,0,0,1,784.76,1256.115Zm-3.58-.23,3.518.027.883-1.732-.855-1.747-3.519-.029Z"
                    transform="translate(-780.977 -1252.201)"
                  />
                </g>
                <g transform="translate(35.478 27.257)">
                  <path
                    :fill="iconColor"
                    d="M803.168,1256.262h0l-3.682-.03a.1.1,0,0,1-.089-.056l-.907-1.849a.108.108,0,0,1,0-.091l.936-1.833a.1.1,0,0,1,.09-.055h0l3.681.029a.1.1,0,0,1,.1.1l-.029,3.682A.1.1,0,0,1,803.168,1256.262Zm-3.618-.232,3.517.029.029-3.48-3.519-.028-.884,1.732Z"
                    transform="translate(-798.479 -1252.348)"
                  />
                </g>
                <g transform="translate(27.106 35.482)">
                  <path
                    :fill="iconColor"
                    d="M793.891,1265.393h0l-3.682-.03a.1.1,0,0,1-.1-.1l.03-3.682a.1.1,0,0,1,.056-.09l1.848-.905a.1.1,0,0,1,.091,0l1.834.935a.1.1,0,0,1,.055.09l-.029,3.682A.1.1,0,0,1,793.891,1265.393Zm-3.58-.232,3.479.028.028-3.518-1.733-.883-1.746.856Z"
                    transform="translate(-790.107 -1260.573)"
                  />
                </g>
                <g transform="translate(27.252 17.979)">
                  <path
                    :fill="iconColor"
                    d="M792.188,1247.891a.092.092,0,0,1-.045-.012l-1.834-.936a.1.1,0,0,1-.056-.09l.029-3.682a.1.1,0,0,1,.1-.1h0l3.681.03a.1.1,0,0,1,.1.1l-.029,3.682a.1.1,0,0,1-.057.09l-1.848.906A.1.1,0,0,1,792.188,1247.891Zm-1.732-1.1,1.733.884,1.747-.857.028-3.517-3.48-.029Z"
                    transform="translate(-790.253 -1243.07)"
                  />
                </g>
                <g transform="translate(93.913 16.44)">
                  <path
                    :fill="iconColor"
                    d="M860.9,1249.493h-.033a4.019,4.019,0,1,1,.033,0Zm0-7.571a3.591,3.591,0,0,0-.028,7.182h.03a3.569,3.569,0,0,0,2.518-1.033h0a3.589,3.589,0,0,0-2.52-6.149Z"
                    transform="translate(-856.914 -1241.531)"
                  />
                </g>
                <g transform="translate(81.01 29.137)">
                  <path
                    :fill="iconColor"
                    d="M847.991,1262.191a3.979,3.979,0,0,1-2.793-6.817,3.89,3.89,0,0,1,2.824-1.145,3.981,3.981,0,0,1-.031,7.962Zm0-7.57a3.588,3.588,0,1,0,2.56,1.07A3.581,3.581,0,0,0,847.991,1254.621Z"
                    transform="translate(-844.011 -1254.228)"
                  />
                </g>
                <g transform="translate(79.499 14.929)">
                  <path
                    :fill="iconColor"
                    d="M848.065,1263.7a5.562,5.562,0,0,1-3.9-9.527l12.756-12.555a5.523,5.523,0,0,1,3.9-1.6h.045a5.565,5.565,0,0,1,3.86,9.53h0L851.968,1262.1A5.541,5.541,0,0,1,848.065,1263.7Zm12.754-23.291a5.142,5.142,0,0,0-3.629,1.486l-12.755,12.555a5.174,5.174,0,0,0,7.259,7.376l12.756-12.555a5.174,5.174,0,0,0-3.589-8.862Zm3.768,9h0Z"
                    transform="translate(-842.5 -1240.02)"
                  />
                </g>
                <g transform="translate(106.753 22.268)">
                  <path
                    :fill="iconColor"
                    d="M873.735,1255.32a3.98,3.98,0,0,1,0-7.961h.034a3.982,3.982,0,0,1,2.761,6.82h0A3.968,3.968,0,0,1,873.735,1255.32Zm0-7.569a3.591,3.591,0,1,0,2.521,6.15h0a3.59,3.59,0,0,0-2.521-6.15Zm2.658,6.289h0Z"
                    transform="translate(-869.754 -1247.359)"
                  />
                </g>
                <g transform="translate(93.851 34.97)">
                  <path
                    :fill="iconColor"
                    d="M860.832,1268.022H860.8a3.947,3.947,0,0,1-2.806-1.188,3.982,3.982,0,1,1,5.631.044l-.137-.139.137.139A3.954,3.954,0,0,1,860.832,1268.022Zm0-7.572a3.592,3.592,0,0,0-.029,7.183,3.525,3.525,0,0,0,2.549-1.032,3.591,3.591,0,0,0-2.52-6.151Z"
                    transform="translate(-856.852 -1260.061)"
                  />
                </g>
                <g transform="translate(92.342 20.761)">
                  <path
                    :fill="iconColor"
                    d="M860.906,1269.53A5.562,5.562,0,0,1,857,1260l12.756-12.555a5.564,5.564,0,1,1,7.8,7.931l-.136-.139.136.139-12.754,12.555A5.546,5.546,0,0,1,860.906,1269.53Zm12.755-23.289a5.159,5.159,0,0,0-3.63,1.485l-12.756,12.554a5.174,5.174,0,0,0,3.589,8.862h.042a5.141,5.141,0,0,0,3.629-1.487L877.29,1255.1a5.172,5.172,0,0,0-3.629-8.861Z"
                    transform="translate(-855.343 -1245.852)"
                  />
                </g>
              </g>
              <g transform="translate(40 43.21)">
                <path
                  :fill="iconColor"
                  d="M772.316,1168.571a.7.7,0,0,1-.483-1.214c14.715-13.879,37.121-13.872,51.008.014a.7.7,0,0,1-.994.994c-13.346-13.346-34.891-13.34-49.049.014A.7.7,0,0,1,772.316,1168.571Z"
                  transform="translate(-771.613 -1156.952)"
                />
                <g transform="translate(6.038 5.415)">
                  <path
                    :fill="iconColor"
                    d="M784.969,1177.291a.468.468,0,0,1-.321-.81c11.273-10.632,28.436-10.627,39.074.01a.468.468,0,0,1-.663.662c-10.277-10.277-26.867-10.273-37.768.01A.467.467,0,0,1,784.969,1177.291Z"
                    transform="translate(-784.5 -1168.51)"
                  />
                </g>
                <g transform="translate(12.012 11.672)">
                  <path
                    :fill="iconColor"
                    d="M797.6,1188.019a.352.352,0,0,1-.241-.607c7.846-7.4,19.792-7.4,27.2.007a.351.351,0,1,1-.5.5c-7.134-7.133-18.65-7.131-26.218.007A.349.349,0,0,1,797.6,1188.019Z"
                    transform="translate(-797.25 -1181.864)"
                  />
                </g>
                <g transform="translate(18.923 18.311)">
                  <path
                    :fill="iconColor"
                    d="M812.234,1199.18a.234.234,0,0,1-.161-.4,9.6,9.6,0,0,1,13.446,0,.235.235,0,0,1-.332.332,9.138,9.138,0,0,0-12.793,0A.232.232,0,0,1,812.234,1199.18Z"
                    transform="translate(-812 -1196.033)"
                  />
                </g>
                <g transform="translate(23.257 23.684)">
                  <path
                    :fill="iconColor"
                    d="M823.827,1212.654a2.577,2.577,0,1,1,2.577-2.577A2.58,2.58,0,0,1,823.827,1212.654Zm0-4.686a2.108,2.108,0,1,0,2.108,2.108A2.111,2.111,0,0,0,823.827,1207.969Z"
                    transform="translate(-821.25 -1207.5)"
                  />
                </g>
              </g>
              <path
                :fill="iconColor"
                d="M150.32,1309.611a2.316,2.316,0,0,0-1.607-1.508l-9.236-1.979-.559-3.384,2.97-6.726a6.864,6.864,0,0,0,.351-2.167v-4.693a9.655,9.655,0,0,0-19.31,0v4.693a6.885,6.885,0,0,0,.376,2.23l2.945,6.663-.559,3.384-9.28,1.99a2.3,2.3,0,0,0-1.566,1.5l-2.621,8.242a1.245,1.245,0,0,0,1.181,1.633h38.357a1.245,1.245,0,0,0,1.183-1.629Zm-36.733,8.691v0Zm.077-.242,2.545-8a.852.852,0,0,1,.545-.553l9.714-2.081a.715.715,0,0,0,.556-.586l.674-4.077a.722.722,0,0,0-.052-.407l-3.007-6.8a5.386,5.386,0,0,1-.278-1.712v-4.693a8.221,8.221,0,0,1,16.442,0v4.693a5.4,5.4,0,0,1-.254,1.649l-3.031,6.859a.709.709,0,0,0-.05.407l.673,4.077a.715.715,0,0,0,.556.586l9.67,2.069a.866.866,0,0,1,.588.558l2.547,8.007Z"
                transform="translate(-112.162 -1279.5)"
              />
              <path
                :fill="iconColor"
                d="M150.32,1309.611a2.316,2.316,0,0,0-1.607-1.508l-9.236-1.979-.559-3.384,2.97-6.726a6.864,6.864,0,0,0,.351-2.167v-4.693a9.655,9.655,0,0,0-19.31,0v4.693a6.885,6.885,0,0,0,.376,2.23l2.945,6.663-.559,3.384-9.28,1.99a2.3,2.3,0,0,0-1.566,1.5l-2.621,8.242a1.245,1.245,0,0,0,1.181,1.633h38.357a1.245,1.245,0,0,0,1.183-1.629Zm-36.733,8.691v0Zm.077-.242,2.545-8a.852.852,0,0,1,.545-.553l9.714-2.081a.715.715,0,0,0,.556-.586l.674-4.077a.722.722,0,0,0-.052-.407l-3.007-6.8a5.386,5.386,0,0,1-.278-1.712v-4.693a8.221,8.221,0,0,1,16.442,0v4.693a5.4,5.4,0,0,1-.254,1.649l-3.031,6.859a.709.709,0,0,0-.05.407l.673,4.077a.715.715,0,0,0,.556.586l9.67,2.069a.866.866,0,0,1,.588.558l2.547,8.007Z"
                transform="translate(-26.162 -1231.826)"
              />
            </g>
          </svg>
          <p class="service-name">{{ services[3].name }}</p>
        </li>
        <li
          :class="{ btn: selected2.includes(services[4].id) }"
          @click="
                        selected2.includes(services[4].id)
                            ? (selected2.splice(selected2.indexOf(services[4].id), 1),
                              selectedPoint.splice(selectedPoint.indexOf(services[4].point), 1))
                            : (selected2.push(services[4].id),
                              selectedPoint.push(services[4].point)),
                            addPlanMulti()
                    "
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="music" viewBox="0 0 94.01 133.503">
            <g transform="translate(0.1 0.1)">
              <g transform="translate(20 81.021)">
                <path
                  :fill="iconColor"
                  d="M1161.577,974.239h9.41a10.636,10.636,0,1,0,0-21.273c-.071,0-.142,0-.213.006a17.289,17.289,0,0,0-32.9,0,10.635,10.635,0,0,0,.142,21.269h8.939"
                  transform="translate(-1127.378 -941)"
                />
                <g transform="translate(19.31 30.214)">
                  <line :fill="iconColor" y2="18.397" transform="translate(7.697)" />
                  <path
                    :fill="iconColor"
                    d="M1161.727,977.847l-7.7,7.7-7.7-7.7"
                    transform="translate(-1146.333 -967.147)"
                  />
                  <line :fill="iconColor" x2="15.225" transform="translate(0.401 21.568)" />
                </g>
              </g>
              <g transform="translate(80.372 49.547)">
                <path
                  :fill="iconColor"
                  d="M459.31,1225.573h-9.438a.5.5,0,0,1-.5-.5v-35.4a.5.5,0,0,1,.5-.5h9.438a3.5,3.5,0,0,1,3.5,3.5v29.4A3.5,3.5,0,0,1,459.31,1225.573Zm-8.938-1h8.938a2.5,2.5,0,0,0,2.5-2.5v-29.4a2.5,2.5,0,0,0-2.5-2.5h-8.938Z"
                  transform="translate(-449.372 -1189.172)"
                />
              </g>
              <g transform="translate(0 49.547)">
                <path
                  :fill="iconColor"
                  d="M381.938,1225.573H372.5a3.5,3.5,0,0,1-3.5-3.5v-29.4a3.5,3.5,0,0,1,3.5-3.5h9.438a.5.5,0,0,1,.5.5v35.4A.5.5,0,0,1,381.938,1225.573Zm-9.438-35.4a2.5,2.5,0,0,0-2.5,2.5v29.4a2.5,2.5,0,0,0,2.5,2.5h8.938v-34.4Z"
                  transform="translate(-369 -1189.172)"
                />
              </g>
              <g transform="translate(12.438 47.633)">
                <path
                  :fill="iconColor"
                  d="M388.692,1227.487h-2.754a4.5,4.5,0,0,1-4.5-4.5v-31.229a4.5,4.5,0,0,1,4.5-4.5h2.754a2.36,2.36,0,0,1,2.358,2.357v35.515A2.36,2.36,0,0,1,388.692,1227.487Zm-2.754-39.229a3.5,3.5,0,0,0-3.5,3.5v31.229a3.5,3.5,0,0,0,3.5,3.5h2.754a1.359,1.359,0,0,0,1.358-1.357v-35.515a1.359,1.359,0,0,0-1.358-1.357Z"
                  transform="translate(-381.438 -1187.258)"
                />
              </g>
              <g transform="translate(71.76 47.633)">
                <path
                  :fill="iconColor"
                  d="M445.872,1227.487h-2.754a2.36,2.36,0,0,1-2.358-2.357v-35.515a2.36,2.36,0,0,1,2.358-2.357h2.754a4.5,4.5,0,0,1,4.5,4.5v31.229A4.5,4.5,0,0,1,445.872,1227.487Zm-2.754-39.229a1.359,1.359,0,0,0-1.358,1.357v35.515a1.359,1.359,0,0,0,1.358,1.357h2.754a3.5,3.5,0,0,0,3.5-3.5v-31.229a3.5,3.5,0,0,0-3.5-3.5Z"
                  transform="translate(-440.76 -1187.258)"
                />
              </g>
              <g transform="translate(6.03)">
                <path
                  :fill="iconColor"
                  d="M456.4,1190.047h-3.828a.375.375,0,0,1-.375-.375v-24.336a21.4,21.4,0,0,0-21.4-21.4h-29.8a21.4,21.4,0,0,0-21.4,21.4v24.336a.375.375,0,0,1-.375.375H375.4a.375.375,0,0,1-.375-.375v-26.383a22.009,22.009,0,0,1,6.488-15.663l1.514-1.514a22.008,22.008,0,0,1,15.663-6.487h34.42a22.006,22.006,0,0,1,15.663,6.487l1.514,1.514a22.008,22.008,0,0,1,6.488,15.663v26.383A.375.375,0,0,1,456.4,1190.047Zm-3.453-.75h3.078v-26.008a21.26,21.26,0,0,0-6.268-15.132l-1.514-1.513h0a21.257,21.257,0,0,0-15.133-6.269H398.7a21.259,21.259,0,0,0-15.133,6.269l-1.514,1.513a21.26,21.26,0,0,0-6.268,15.132V1189.3h3.078v-23.961a22.148,22.148,0,0,1,22.15-22.15h29.8a22.148,22.148,0,0,1,22.149,22.15Z"
                  transform="translate(-375.03 -1139.625)"
                />
              </g>
              <g transform="translate(30.618 3.663)">
                <path
                  :fill="iconColor"
                  d="M431.247,1149.072a.423.423,0,0,1-.062,0l-4.4-.545a86.033,86.033,0,0,0-21.982.113l-3.218.431h-.01a1.791,1.791,0,0,1-1.958-1.609v-3.67a.5.5,0,0,1,.5-.5h32.531a.5.5,0,0,1,.5.5v3.67A1.778,1.778,0,0,1,431.247,1149.072Zm-30.629-4.784v3.17c0,.333.413.614.9.614l3.151-.426a86.981,86.981,0,0,1,22.238-.115l4.366.541c.476-.01.874-.288.874-.614v-3.17Z"
                  transform="translate(-399.618 -1143.288)"
                />
              </g>
              <g transform="translate(85.406 85.198)">
                <path
                  :fill="iconColor"
                  d="M456.079,1230.107h-.933a.741.741,0,0,1-.74-.74v-4.294a.251.251,0,0,1,.25-.25h1.913a.25.25,0,0,1,.25.25v4.294A.741.741,0,0,1,456.079,1230.107Zm-1.173-4.784v4.044a.24.24,0,0,0,.24.24h.933a.24.24,0,0,0,.24-.24v-4.044Z"
                  transform="translate(-454.406 -1224.823)"
                />
              </g>
            </g>
          </svg>
          <p class="service-name">{{ services[4].name }}</p>
        </li>
        <li
          :class="{ btn: selected2.includes(services[5].id) }"
          @click="
                        selected2.includes(services[5].id)
                            ? (selected2.splice(selected2.indexOf(services[5].id), 1),
                              selectedPoint.splice(selectedPoint.indexOf(services[5].point), 1))
                            : (selected2.push(services[5].id),
                              selectedPoint.push(services[5].point)),
                            addPlanMulti()
                    "
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="videos" viewBox="0 0 64.131 101.941">
            <g transform="translate(0.5 0.5)">
              <g transform="translate(4.728 49.058)">
                <path
                  :fill="iconColor"
                  d="M1161.577,974.239h9.41a10.636,10.636,0,1,0,0-21.273c-.071,0-.142,0-.213.006a17.289,17.289,0,0,0-32.9,0,10.635,10.635,0,0,0,.142,21.269h8.939"
                  transform="translate(-1127.378 -941)"
                />
                <g transform="translate(19.31 30.214)">
                  <line :fill="iconColor" y2="18.397" transform="translate(7.697)" />
                  <path
                    :fill="iconColor"
                    d="M1161.727,977.847l-7.7,7.7-7.7-7.7"
                    transform="translate(-1146.333 -967.147)"
                  />
                  <line :fill="iconColor" x2="15.225" transform="translate(0.401 21.568)" />
                </g>
              </g>
              <path
                :fill="iconColor"
                d="M336.355,712.95a31.627,31.627,0,1,1,44.777-.049"
                transform="translate(-327.154 -659.021)"
              />
              <path
                :fill="iconColor"
                d="M335.522,708.065a28.763,28.763,0,1,1,40.721-.044"
                transform="translate(-324.195 -656.379)"
              />
              <path
                class="d"
                d="M1680.545,651.53a1.9,1.9,0,0,1,0,3.293l-7.212,4.164-7.213,4.164a1.9,1.9,0,0,1-2.85-1.646V644.848a1.9,1.9,0,0,1,2.85-1.645l7.213,4.164Z"
                transform="translate(-1639.382 -621.676)"
              />
            </g>
          </svg>
          <p class="service-name">{{ services[5].name }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Services",
  props: ["points"],
  data() {
    return {
      iconColor: "#ff8412",
      services: [
        {
          name: "Rede sociais",
          id: 0,
          point: this.points[12].item_points
        },
        {
          name: "SPOTIFY, DEEZER",
          id: 1,
          point: this.points[13].item_points
        },
        {
          name: "NETFLIX,YOUTUBE",
          id: 2,
          point: this.points[14].item_points
        },
        {
          name: "Jogos online",
          id: 3,
          point: this.points[15].item_points
        },
        {
          name: "Download de músicas",
          id: 4,
          point: this.points[16].item_points
        },
        {
          name: "Download de vídeos",
          id: 5,
          point: this.points[17].item_points
        }
      ],
      selected2: [],
      selectedPoint: []
    };
  },
  methods: {
    addPlanMulti() {
      this.$store.commit(
        "ADD_PLAN_MULTI_TWO",
        this.selectedPoint.reduce((a, b) => a + b, 0)
      );
    }
  },
  created() {
    console.log(this.points[14].item_points);
    console.log(this.points[15].item_points);
    console.log(this.points[17].item_points);
    if (this.$store.state.plan === 3) {
      this.points[14].item_points = 3;
      this.points[15].item_points = 3;
      this.points[17].item_points = 3;
    }
    console.log(this.points[14].item_points);
    console.log(this.points[15].item_points);
    console.log(this.points[17].item_points);
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/style";
li.btn p {
  color: $purple;
}

li.btn svg path {
  fill: $purple;
}
li.btn svg circle {
  fill: $purple;
}

.socialmidia {
  width: 169px;
  height: 175px;
}

.games {
  width: 127px;
  height: 154px;
}

.spotify {
  width: 194px;
  height: 187px;
}

.netflix {
  width: 151px;
  height: 132px;
}

.music {
  width: 107px;
  height: 152px;
}

.videos {
  width: 72px;
  height: 115px;
}

.btn::before {
  content: url("../../public/Polígono_1.png");
  color: $purple;
  position: absolute;
  left: 29%;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
}

.select-title {
  color: $purple;
}

.a,
.b,
.c {
  fill: #ff8412;
  stroke: #ff8511;
  stroke-width: 0.2px;
}

.d {
  fill: #fafafa !important;
}

p {
  text-align: left;
  font-size: 21px;
  font-weight: 500;
  color: $light-orange;
}

.service-name {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  margin-top: 20px;
  color: $light-orange;
}

/* width */
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #e0e0e0;
  border-radius: 6px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #ff8711;
  border-radius: 6px;
}

.obs {
  font-size: 14px;
  color: #6c4d90;
  margin-top: 10px;
}

@media only screen and (max-width: 600px) {
  .wrapper-services {
    padding: 1em;
  }

  .slide {
    text-align-last: center;

    ul {
      display: flex;
      flex-wrap: wrap;
      margin-top: 2em;

      li {
        max-width: 112px;
        margin-right: 0;
        margin-bottom: 1.5em;
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: center;
      }

      li:nth-child(odd) {
        margin-right: 3em;
      }
      li:nth-child(3) {
        margin-right: 4.2em;
      }
    }
  }

  .service-netflix-name {
    margin-top: 29px;
  }

  .socialmidia {
    width: 102px;
    height: 105px;
  }

  .games {
    width: 76px;
    height: 92px;
  }

  .spotify {
    width: 122px;
    height: 105px;
  }

  .netflix {
    width: 95px;
    height: 83px;
  }

  .music {
    width: 56px;
    height: 79px;
  }

  .videos {
    width: 49px;
    height: 79px;
  }

  .btn::before {
    top: -10%;
  }

  p {
    text-align: left;
  }
}

@media only screen and (min-width: 1024px) {
  .slide {
    margin-top: 2em;

    ul {
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;

      div {
        display: flex;
        align-items: baseline;
      }

      li {
        width: 200px;
        padding-top: 2rem;
        padding-bottom: 2rem;
        position: relative;
        cursor: pointer;
        text-align: center;
      }
    }
  }

  .socialmidia {
    width: 102px;
    height: 105px;
  }

  .games {
    width: 76px;
    height: 92px;
  }

  .spotify {
    width: 122px;
    height: 105px;
  }

  .netflix {
    width: 95px;
    height: 83px;
  }

  .music {
    width: 56px;
    height: 79px;
  }

  .videos {
    width: 49px;
    height: 79px;
  }
}
</style>
